<template>
  <router-view/>
</template>

<style lang="scss">
// main styles in the vue.config.js
</style>


